module.exports = __webpack_public_path__ + "assets/assets/images/home/home-illustration.3d62b21a.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/home/home-illustration.png
// module id = 429
// module chunks = 0